export default __webpack_public_path__ + "static/media/users.a9dd7265.svg";